<div class="atn-variables">
  @for (
    variable of variablesFeature.selectors.focusedDefinitions.asSignal();
    track $index
  ) {
    <atn-display-variable
      [variable]="variable"
      [value]="
        variablesFeature.selectors
          .getFromFocusedValues({ id: variable.id })
          .asSignal()
      "
      (valueChange)="valueChangeHandler($event, variable)"
    />
  }
</div>
